import React from 'react'
import PropTypes from 'prop-types'

import { NavLink } from "react-router-dom"

/**
 * NavButton — a nav item with a unified filled icon (react-icons component) + label.
 * @param {string} text
 * @param {React.ElementType} Icon - react-icons component (filled family)
 * @param {string} to
 */
const NavButton = ({ text, Icon, to }) => {
  return (
    <NavLink to={to}>
      <div className="flex flex-row items-center gap-2 cursor-pointer">
        {Icon ? <Icon size={18} className="text-primary-contrast shrink-0" /> : null}
        <span className="text-md text-primary-contrast mt-0.5">{text}</span>
      </div>
    </NavLink>
  )
}

NavButton.propTypes = {
  text: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
}

NavButton.defaultProps = {
  text: 'Tab',
  to: '',
}

export default NavButton
